/**
 * Get List
 */
export const GET_ORGANIZATION_LIST = "web/GET_ORGANIZATION_LIST";
export const GET_ORGANIZATION_LIST_SUCCESS = "web/GET_ORGANIZATION_LIST_SUCCESS";
export const GET_ORGANIZATION_LIST_FAILURE = "web/GET_ORGANIZATION_LIST_FAILURE";
